import { useEffect, useState } from 'react';
import { useDarkMode } from '@leafygreen-ui/leafygreen-provider';
import { ThemePreference } from './themePreference';
import { customColors, leafygreenColors } from './colors';
import { auto, disable, enable, setFetchMethod } from './api';
import useThemeValue from './useThemeValue';
const options = getOptionsOverride() || {};
// CSS overrides only for when DarkReader is enabled
const css = `
.monaco-editor{
  .view-overlays {
    .current-line {
      background-color: var(--mdb-grayDark4);
      border-width: 0px !important;
    }
  }

  .margin-view-overlays {
    .current-line {
      background-color: var(--mdb-grayDark4);
    }
  }

  .cursors-layer {
    .cursor {
      background-color: var(--mdb-grayLight2) !important;
      border-color: var(--mdb-grayLight2) !important;
      color: var(--mdb-grayLight2) !important;
    }
  }
}
`;
const dynamicFixes = {
    url: [],
    invert: [".darkreader-invert"], // svgs, other elements can be inverted by appending this class
    css,
    ignoreImageAnalysis: [],
    ignoreInlineStyle: ['div[role=tooltip] svg', 'svg[aria-label="MongoDB Logo"] path', '.profiler-scatterplot .domain', '.profiler-scatterplot .tick line', '.darkreader-ignore-inline-style', '.darkreader-ignore-child-inline-style *'],
    disableStyleSheetsProxy: false,
};
const setFetch = () => {
    if (window?.fetch) {
        setFetchMethod(window.fetch);
    }
};
/**
 *
 * @param themePreference One of LIGHT, DARK, or OS
 */
export default function useDarkReader(themePreference) {
    const { setDarkMode } = useDarkMode();
    const [darkReaderEnabled, setDarkReaderEnabled] = useState(false);
    useEffect(() => {
        if (themePreference === ThemePreference.OS) {
            setFetch();
            auto(options, dynamicFixes, (enabled) => {
                setDarkReaderEnabled(enabled);
            });
        }
        else {
            auto(false);
            if (themePreference === ThemePreference.DARK) {
                setFetch();
                setDarkReaderEnabled(true);
                enable(options, dynamicFixes);
            }
            else {
                setDarkReaderEnabled(false);
                disable();
            }
        }
    }, [themePreference]);
    useEffect(() => {
        setDarkMode(darkReaderEnabled);
    }, [setDarkMode, darkReaderEnabled]);
    return darkReaderEnabled;
}
// Let people override the options with a local storage item for testing
function getOptionsOverride() {
    const localStorageItem = localStorage.getItem('mmsDarkReader');
    return localStorageItem && JSON.parse(localStorageItem);
}
export { customColors, leafygreenColors, ThemePreference, useThemeValue };
